import { defineComponent as _defineComponent } from 'vue'
import * as validation from 'JS/components/blain-form/validation';
import BForm from 'JS/components/blain-form/BForm.vue';
import ErrorBanner from 'JS/components/ErrorBanner.vue';
import HorizontalTextDivider from 'JS/components/HorizontalTextDivider.vue';
import LinkButton from 'JS/components/LinkButton.vue';
import { BPhoneNumberField, BSubmitButton, BTextField } from "Src/js/components/blain-form";
import { IJoinRewardsStep, ILinkRewardsUser, ILinkRewardsUserResponse, IVerifyUserData, RewardsReasonCode } from 'JS/types/rewards';
import { onMounted, ref } from 'vue';
import { useServices } from '../../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'ConnectRewardsForm',
  props: {
	customerEmail: {
		type: String,
		defaultValue: ""
	}
},
  emits: ["switch-page", "loading"],
  setup(__props, { emit }: { emit: ({
	(e: 'switch-page', page: IJoinRewardsStep, data?: IVerifyUserData): void,
	(e: 'loading', value: boolean): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const { rewardsService } = useServices();

const phoneNumber = ref<string>("");
const emailAddress = ref<string>("");
const rewardsNumber = ref<string>("");
const errorMessage = ref<string>("");
const headerFocuser = ref<HTMLElement | null>(null);

async function submitLinkUserData() {
	if (phoneNumber.value && emailAddress.value || phoneNumber.value && rewardsNumber.value || emailAddress.value && rewardsNumber.value) {
		errorMessage.value = "<span class='bold'>Please only enter one piece of information.</span>";
		return;
	}
	emit('loading', true);
	const userRewardsData: ILinkRewardsUser = {
		phoneNumber: phoneNumber.value,
		rewardsNumber: rewardsNumber.value,
		email: emailAddress.value
	};
	const results: ILinkRewardsUserResponse = await rewardsService.linkUser(userRewardsData);
	//since we are not passing VerificationInfo we should not receive a success
	if (results?.success ?? true) {
		errorMessage.value = "<span class='bold'>Something went wrong. Please try again or call Customer Service at 1-800-210-2370.</span>";
	} else {
		let redactedData: 'both' | 'email' | 'phone';
		if (rewardsNumber.value) {
			redactedData = 'both';
		} else if (phoneNumber.value) {
			redactedData = 'email';
		} else {
			redactedData = 'phone';
		}

		switch (results.reasonCode) {
			case RewardsReasonCode.CUSTOMER_HAS_REWARDS:
				emit('switch-page', 'customer-has-rewards');
				break;
			case RewardsReasonCode.VERIFICATION_REQUIRED:
				emit('switch-page', 'verification-connect', {
					phone: results.phone,
					email: results.email,
					rewardsNumber: rewardsNumber.value,
					variant: 'verification-connect',
					redactedData: redactedData,
				});
				break;
			case RewardsReasonCode.REWARDS_ACCOUNT_ALREADY_LINKED:
				emit('switch-page', 'account-in-use', {
					phone: results.phone,
					email: results.email,
					rewardsNumber: rewardsNumber.value,
					variant: 'account-in-use',
					redactedData: redactedData,
				});
				break;
			default:
				errorMessage.value = results.errorMessage;
		}
	}
	emit('loading', false);
}

onMounted(() => {
	emailAddress.value = props.customerEmail;
	headerFocuser.value?.focus();
});


return { __sfc: true,props, emit, rewardsService, phoneNumber, emailAddress, rewardsNumber, errorMessage, headerFocuser, submitLinkUserData, validation, BForm, ErrorBanner, HorizontalTextDivider, LinkButton, BPhoneNumberField, BSubmitButton, BTextField }
}

})